import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PARK_URL } from "@/lib/assets";

const dateFmt = (iso) => iso ? new Date(iso).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }) : "";

export function BlogList() {
  const [posts, setPosts] = useState([]);
  const [cat, setCat] = useState("All");
  useEffect(() => { api.get("/blog" + (cat !== "All" ? `?category=${cat}` : "")).then(r => setPosts(r.data)); }, [cat]);
  const cats = ["All", ...Array.from(new Set(posts.map(p => p.category).filter(Boolean)))];

  return (
    <div className="bg-cream">
      <div className="brand-container py-20">
        <div className="brand-eyebrow">The Blog</div>
        <h1 className="brand-h1 mt-3 mb-4">Reflections from the porch.</h1>
        <p className="brand-lede max-w-2xl">Essays, five-takeaways series, and honest talk from a retired judge who still has plenty to say.</p>

        <div className="mt-10 flex flex-wrap gap-2">
          {cats.map(c => (
            <button key={c} onClick={() => setCat(c)}
              className={`px-4 py-1.5 rounded-full text-sm border transition-colors ${cat === c ? "bg-plum text-cream border-plum" : "border-gold-light text-charcoal/70 hover:text-plum"}`}
              data-testid={`blog-cat-${c}`}>
              {c}
            </button>
          ))}
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((p) => (
            <Link to={`/blog/${p.slug || p.id}`} key={p.id} className="editorial-card block" data-testid={`blog-card-${p.id}`}>
              <img src={p.cover_image || PARK_URL} alt="" className="w-full aspect-[4/3] object-cover" />
              <div className="p-6">
                <div className="brand-eyebrow">{p.category}</div>
                <h3 className="mt-3 font-serif text-2xl leading-tight text-charcoal">{p.title}</h3>
                <p className="mt-2 text-sm text-charcoal/60 line-clamp-3">{p.excerpt}</p>
                <div className="mt-4 text-xs text-charcoal/50">{dateFmt(p.created_at)}</div>
              </div>
            </Link>
          ))}
          {posts.length === 0 && <div className="text-charcoal/50 col-span-full">No posts yet — check back soon.</div>}
        </div>
      </div>
    </div>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/blog/${slug}`).then(r => setP(r.data)).catch(() => setErr("Post not found")); }, [slug]);

  if (err) return <div className="brand-container py-20 text-charcoal/60">{err}</div>;
  if (!p) return <div className="brand-container py-20 text-charcoal/40">Loading…</div>;

  return (
    <article className="bg-cream">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link to="/blog" className="text-sm text-plum hover:underline" data-testid="blog-back-link">← Back to blog</Link>
        <div className="brand-eyebrow mt-8">{p.category}</div>
        <h1 className="font-serif text-4xl md:text-5xl leading-tight text-charcoal mt-3">{p.title}</h1>
        <div className="mt-4 text-sm text-charcoal/50">{dateFmt(p.created_at)}</div>
        {p.cover_image && <img src={p.cover_image} alt="" className="w-full aspect-video object-cover rounded-lg mt-8" />}
        <div className="prose prose-lg max-w-none mt-10 text-charcoal/85 font-serif leading-relaxed" dangerouslySetInnerHTML={{ __html: p.body }} />
      </div>
    </article>
  );
}
